import { gql } from '@apollo/client'
import { Chip, ChipClickable, Dropdown, MenuItem } from '@farol-ds/react'
import { ChipKindEnum } from '@jusbrasil-web/shared-apollo-client/types'
import classNames from 'classnames'

import { DropdownOffers_OfferLockCardFragment } from './__generated__/dropdown-offers.graphql'
import styles from './dropdown-offers.module.scss'

interface DropdownOffersProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onPlanChange: (planTitle: string) => void
  offerLockCard: DropdownOffers_OfferLockCardFragment[]
  selectedPlanOffer?: DropdownOffers_OfferLockCardFragment | null
}

export const DropdownOffers = ({
  isOpen,
  offerLockCard,
  selectedPlanOffer,
  onOpenChange,
  onPlanChange,
}: DropdownOffersProps) => {
  const matchingPlan = offerLockCard.find((p) => p.title === selectedPlanOffer?.title)
  const chipDescription = matchingPlan?.chip?.description || selectedPlanOffer?.chip?.description
  const planTitle = `Plano ${selectedPlanOffer?.title}`

  const renderDropdownText = () => {
    if (chipDescription)
      return (
        <div>
          {planTitle}
          <span className={styles.triggerDiscount}>{` | ${chipDescription}`}</span>
        </div>
      )

    return planTitle
  }

  return (
    <Dropdown open={isOpen} onOpenChange={onOpenChange}>
      <Dropdown.Trigger asChild>
        <ChipClickable
          selected
          chevron
          onClick={() => onOpenChange(!isOpen)}
          size="lg"
          className={styles.planSelector}
        >
          {renderDropdownText()}
        </ChipClickable>
      </Dropdown.Trigger>

      <Dropdown.Menu side="bottom" placement="start">
        {offerLockCard.map((plan) => {
          const isSelected = plan.title === selectedPlanOffer?.title
          const chipText = plan.chip?.description || plan.chip?.label

          return (
            <Dropdown.MenuItem key={plan.title} onSelect={() => onPlanChange(plan.title)}>
              <MenuItem className={classNames(styles.item, { [styles.selected]: isSelected })}>
                <MenuItem.Content className={classNames({ [styles.selectedText]: isSelected })}>
                  Plano {plan.title}
                </MenuItem.Content>

                {chipText && (
                  <Chip
                    size="sm"
                    kind={plan.chip?.kind ?? ChipKindEnum.Secondary}
                    className={styles.itemChip}
                  >
                    <strong>{chipText}</strong>
                  </Chip>
                )}
              </MenuItem>
            </Dropdown.MenuItem>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

DropdownOffers.fragments = {
  offerLockCard: gql`
    fragment DropdownOffers_offerLockCard on OfferLockCard {
      title
      chip {
        label
        description
        kind
      }
    }
  `,
}
